import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Corretor } from 'src/app/shared/models/corretor';
import { Imovel } from 'src/app/shared/models/imovel';
import { Pagina } from 'src/app/shared/models/pagina';
import { CorretorService } from 'src/app/shared/services/corretor.service';
import { ImovelService } from 'src/app/shared/services/imovel.service';
import { PaginaService } from 'src/app/shared/services/pagina.service';
import { SessionManager } from 'src/app/shared/util/session-manager';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
})
export class SitemapComponent implements OnInit {
  cidadeSlug: string;
  pages$: Observable<Pagina[]>;
  hottest$: Observable<Imovel[]>;
  spots$: Observable<Imovel[]>;
  releases$: Observable<Imovel[]>;
  recents$: Observable<Imovel[]>;
  brokers$: Observable<Corretor[]>;

  constructor(
    private paginaService: PaginaService,
    private imovelService: ImovelService,
    private corretorService: CorretorService,
    private sm: SessionManager
  ) {}

  ngOnInit(): void {
    this.cidadeSlug = this.sm.getSessionData()?.search?.cidade || 'porto-alegre';

    // páginas
    this.pages$ = this.paginaService.getPaginas().pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar páginas');
        return of([] as Pagina[]);
      })
    );

    // mais acessados
    this.hottest$ = this.imovelService.getMaisAcessados(this.cidadeSlug).pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar os imóveis mais acessados');
        return of([] as Imovel[]);
      })
    );

    // destaques
    this.spots$ = this.imovelService.getDestaques(this.cidadeSlug, '0').pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar imóveis em destaque');
        return of([] as Imovel[]);
      })
    );

    // lançamentos
    this.releases$ = this.imovelService.getLancamentos(this.cidadeSlug).pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar os lançamentos');
        return of([] as Imovel[]);
      })
    );

    // recentes
    this.recents$ = this.imovelService.getRecentes(this.cidadeSlug).pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar os recentes');
        return of([] as Imovel[]);
      })
    );

    // corretores
    this.brokers$ = this.corretorService.getCorretores().pipe(
      map(x => x.corretores.filter(y => y.creciSlug)),
      catchError(error => {
        SessionManager.handleHttpError(error, 'Falha ao consultar os corretores');
        return of([] as Corretor[]);
      })
    );
  }
}
